import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Movie = () => (
  <Layout>
    <Switch>
      <Route exact path="/lives" component={List} />
      <Route exact path="/lives/new" component={Form} />
      <Route exact path="/lives/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Movie;
